import { default as Component, PanelLevel } from './panel.component'

export { PanelLevel }
export default Component
